function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_336",
  "data-name": "Group 336",
  transform: "translate(-200 -298.438)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_432",
  "data-name": "Path 432",
  d: "M211.981,300.262h-3.065v-.405a1.42,1.42,0,0,0-1.418-1.418h-2.026a1.42,1.42,0,0,0-1.418,1.418v.405h-3.065a.989.989,0,0,0-.988.988v4.509a.986.986,0,0,0,.405.8V308.6a.989.989,0,0,0,.988.988h10.183a.989.989,0,0,0,.988-.988v-2.041a.986.986,0,0,0,.405-.8V301.25A.989.989,0,0,0,211.981,300.262Zm.583,5.5a.583.583,0,0,1-.583.583H207.6v-.608a.609.609,0,0,0-.608-.608h-1.013a.609.609,0,0,0-.608.608v.608h-4.382a.583.583,0,0,1-.583-.583V301.25a.582.582,0,0,1,.583-.583h10.993a.584.584,0,0,1,.58.523.543.543,0,0,1,0,.059Zm-5.37,1.6a.2.2,0,0,1-.2.2h-1.013a.2.2,0,0,1-.2-.2v-1.621a.2.2,0,0,1,.2-.2h1.013a.2.2,0,0,1,.2.2Zm-2.736-7.5a1.014,1.014,0,0,1,1.013-1.013H207.5a1.014,1.014,0,0,1,1.013,1.013v.405h-4.053Zm7.7,8.739a.583.583,0,0,1-.583.583H201.393a.583.583,0,0,1-.583-.583v-1.866a.987.987,0,0,0,.177.017h4.382v.608a.609.609,0,0,0,.608.608h1.013a.609.609,0,0,0,.608-.608v-.608h4.382a.985.985,0,0,0,.177-.017Z",
  fill: "#fff"
}));

var SvgCompanyIcon = function SvgCompanyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.969,
    height: 11.145,
    viewBox: "0 0 12.969 11.145",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company_icon.e11dcf3f.svg";
export { ForwardRef as ReactComponent };